// extracted by mini-css-extract-plugin
export default {"paymentImage":"paymentMethod_paymentImage__RTXOG","card":"paymentMethod_card__hyjNf","radio":"paymentMethod_radio__CguTY"};